import { useEffect } from "react";
import Lenis from "lenis";
import "@/App.css";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import AlbumLaunch from "@/components/AlbumLaunch";
import Concerts from "@/components/Concerts";
import Booking from "@/components/Booking";
import Bio from "@/components/Bio";
import Endorsement from "@/components/Endorsement";
import Gallery from "@/components/Gallery";
import Studio from "@/components/Studio";
import Newsletter from "@/components/Newsletter";
import InstagramSection from "@/components/InstagramSection";
import Footer from "@/components/Footer";
import RandomPreview from "@/components/RandomPreview";
import Merch from "@/components/Merch";
import CartDrawer from "@/components/CartDrawer";
import { CartProvider } from "@/cart";
import { PaymentSuccess, PaymentCancel } from "@/pages/PaymentPages";
import { Toaster } from "sonner";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import AdminPage from "@/pages/AdminPage";

function Site() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    window.__lenis = lenis;
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <div className="min-h-screen overflow-x-hidden bg-[#070707] text-neutral-200">
      <div className="grain-overlay" aria-hidden="true" />
      <Navbar />
      <main>
        <Hero />
        <Marquee />
        <AlbumLaunch />
        <Concerts />
        <Booking />
        <Bio />
        <Endorsement />
        <Gallery />
        <Studio />
        <Merch />
        <InstagramSection />
        <Newsletter />
      </main>
      <Footer />
      <RandomPreview />
      <CartDrawer />
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <CartProvider>
      <Routes>
        <Route path="/" element={<Site />} />
        <Route path="/admin" element={<AdminPage />} />
        <Route path="/payment/success" element={<PaymentSuccess />} />
        <Route path="/payment/cancel" element={<PaymentCancel />} />
      </Routes>
      <Toaster
        theme="dark"
        position="bottom-center"
        toastOptions={{
          style: {
            background: "#0D0D0D",
            border: "1px solid rgba(200,16,46,0.5)",
            color: "#e5e5e5",
            borderRadius: 0,
          },
        }}
      />
      </CartProvider>
    </BrowserRouter>
  );
}

export default App;
